const each = (array, func, inc = 1) => {
    for (let i = 0; i < array.length; i += inc) {
        func(array[i], i);
    }
};

export {each};
